import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { DeliveryTransportsViewForCargoDriver } from "src/components/views/erp/delivery/deliveryTransport/cargoDriverViews/DeliveryTransportsViewForCargoDriver.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/delivery/ownTransports")({
	staticData: { title: i18n.t("own_transports"), legacyViewKey: "userDeliveryTransportsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <DeliveryTransportsViewForCargoDriver />;
}
